import React, { FunctionComponent, memo } from "react"
import { useImageUrl } from "../../hooks/useImageUrl"
import { eImageVersions } from "../../definitions/Image"
import { iArtPiece } from "../../definitions/ArtPieces"
import PureImage from "../../components/Image/PureImage"
import { useImage } from "../../hooks/useImage"
interface iProps {
  showViewButton?: boolean
}

const ArtPieceItem: FunctionComponent<iArtPiece & iProps> = ({
  fileVersions,
  shrPreviewImageId,
  shrTitle,
  shrUrl,
  showViewButton = false,
}) => {
  let src = ""
  let versions = fileVersions
  if (!fileVersions) {
    const { file } = useImage({
      fileId: shrPreviewImageId,
      fileCollection: "Files_ArtPiecesPreview",
    })
    versions = file?.versions
  }
  src = useImageUrl(eImageVersions.LIcon, versions)

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage src={src} />
      </div>
      <div className="content-block">
        <h3>{shrTitle}</h3>
        {showViewButton && (
          <div className="view-item">
            <a
              onClick={(e) => e.stopPropagation()}
              target="_blank"
              href={`/art-pieces/${shrUrl}`}
              rel="noreferrer"
            >
              View
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

function isEqual(prev: iArtPiece, next: iArtPiece) {
  return prev.shrTitle === next.shrTitle && prev.shrUrl === next.shrUrl
}

export default memo(ArtPieceItem, isEqual)
